import React, { ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";
import { usePermission } from "@/hooks/usePermission";
import { LoginPage } from "@/features/auth/LoginPage";

export interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermissions?: string[];
  requiredRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions,
  requiredRoles,
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { canAccess } = usePermission();

  if (isLoading) {
    return (
      <div className="flex-center loading-screen" data-testid="auth-loading-state">
        <div className="spinner"></div>
        <p className="loading-text">Validando sessão segura...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  const allowed = canAccess(requiredPermissions, requiredRoles);
  if (!allowed) {
    return (
      <div className="access-denied-container" data-testid="access-denied-message">
        <div className="card text-center p-8">
          <h2 className="text-xl font-bold text-red-600 mb-2">Acesso Negado (403)</h2>
          <p className="text-muted mb-4">
            Seu perfil não possui os privilégios ou permissões RBAC necessários para visualizar este
            módulo.
          </p>
          <div className="text-sm bg-gray-50 p-3 rounded">
            Consulte o administrador do tenant para solicitar liberação.
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
